<template>
    <div class="d-loader" :class="classnames">
        <div v-if="full" class="d-full-loader-overlay"></div>
        <LoaderLottie :size="_size" :name="name" />
        <div class="italic mt-1" v-if="hasdefaultslot">
            <span class="loading-text bold">
                <slot></slot>
            </span>
        </div>
    </div>
</template>


<script setup>

import { computed, useSlots, defineProps, toRefs  } from 'vue'
import LoaderLottie from "./Lottie/DLottieLoader.vue"

const slots = useSlots();

// PROPS
const props = defineProps({
    size: { type: Number, default: 200 },
    name: { type: String},
    textalign: { type: String },
    full: { type: Boolean, default: false }
})
const { size, textalign, full } = toRefs(props)

// COMPUTED
const _size = computed(() => {
    if (isNaN(size.value)) {
        return 200;
    } else return parseInt(size.value);
})

const hasdefaultslot = computed(() => slots.default)

const classnames = computed(() => {
    var cnames = "loader";
    if (full)
        cnames += " full-loader";
    switch (textalign) {
        case "left":
            cnames += " text-left";
            break;
        case "right":
            cnames += " text-right";
            break;
        case "center":
        default:
            cnames += " text-center";
            break;
    }

    return cnames;
})

</script>
